<! --
/**
* SuiteCRM is a customer relationship management program developed by SalesAgility Ltd.
* Copyright (C) 2021 SalesAgility Ltd.
*
* This program is free software; you can redistribute it and/or modify it under
* the terms of the GNU Affero General Public License version 3 as published by the
* Free Software Foundation with the addition of the following permission added
* to Section 15 as permitted in Section 7(a): FOR ANY PART OF THE COVERED WORK
* IN WHICH THE COPYRIGHT IS OWNED BY SALESAGILITY, SALESAGILITY DISCLAIMS THE
* WARRANTY OF NON INFRINGEMENT OF THIRD PARTY RIGHTS.
*
* This program is distributed in the hope that it will be useful, but WITHOUT
* ANY WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS
* FOR A PARTICULAR PURPOSE. See the GNU Affero General Public License for more
* details.
*
* You should have received a copy of the GNU Affero General Public License
* along with this program.  If not, see http://www.gnu.org/licenses.
*
* In accordance with Section 7(b) of the GNU Affero General Public License
* version 3, these Appropriate Legal Notices must retain the display of the
* "Supercharged by SuiteCRM" logo. If the display of the logos is not reasonably
* feasible for technical reasons, the Appropriate Legal Notices must display
* the words "Supercharged by SuiteCRM".
*/
-->
<ng-container *ngIf="!field?.loading()">
    <ng-container *ngIf="hasOnClick()">
        <a (click)="onClick()" class="clickable field-link">
            <ndc-dynamic
                [ndcDynamicComponent]="componentType"
                [ndcDynamicInputs]="{
                'mode': mode,
                'originalMode': originalMode,
                'field': field,
                'klass': klass,
                'record': record,
                'parent': parent
            }"
            ></ndc-dynamic>
        </a>
    </ng-container>
    <ng-container *ngIf="isLink() && !hasOnClick()">
        <a [routerLink]="getLink()" [queryParams]="record?.metadata?.queryParams" class="field-link">
            <ndc-dynamic
                [ndcDynamicComponent]="componentType"
                [ndcDynamicInputs]="{
                'mode': mode,
                'originalMode': originalMode,
                'field': field,
                'klass': klass,
                'record': record,
                'parent': parent
            }"
            ></ndc-dynamic>
        </a>
    </ng-container>
    <ng-container *ngIf="!isLink() && !hasOnClick()">
        <ndc-dynamic
            [ndcDynamicComponent]="componentType"
            [ndcDynamicInputs]="{
            'mode': mode,
            'originalMode': originalMode,
            'field': field,
            'klass': klass,
            'record': record,
            'parent': parent
        }"
        ></ndc-dynamic>
    </ng-container>
</ng-container>

<ng-container *ngIf="field?.loading()">
   <div class= "dynamic-field">
        <div class="flex-grow-1 text-break rounded box-loading skeleton-field-content"></div>
   </div>
</ng-container>
<ng-container *ngIf="isEdit() && field.formControl && field.formControl.errors">
    <ng-container *ngIf="validateOnlyOnSubmit ? isInvalid() : (field.formControl.invalid && field.formControl.touched)">
        <div *ngFor="let item of field.formControl.errors | keyvalue" class="invalid-feedback d-block">
            <scrm-dynamic-label [context]="getMessageContext(item.value, record)"
                                [fields]="{field: field}"
                                [labelKey]="getMessageLabelKey(item.value)">
            </scrm-dynamic-label>
        </div>
    </ng-container>
</ng-container>
